module.exports = __webpack_public_path__ + "static/media/loginLogo.4eaa8627.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/loginLogo.png
// module id = 368
// module chunks = 0